import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 20223-09-11
 * @brief SEI 사업장 관리 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { loadingBoxState, siteState } from "../../../recoil/menuState";
import { userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function SiteTree(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    const [siteStates, setSiteStates] = useRecoilState(siteState);
    // props
    const { adminType, setWorkMode, workMode } = props;
    //화면 이동
    const navigate = useNavigate();
    //
    const [companyList, setCompanyList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [treeSearchText, setTreeSearchText] = useState("");
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/companies`,
        appQuery: {
            search: treeSearchText,
        },
        userToken: userInfo.loginInfo.token,
        watch: adminType + workMode + siteStates + treeSearchText,
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompanyList(data.body);
                if (workMode == "READ") {
                    setSiteStates({
                        siteType: "company",
                        companyId: siteStates.companyId ? siteStates.companyId : data.body[0].companyId,
                        companyName: siteStates.companyName ? siteStates.companyName : data.body[0].companyName,
                    });
                }
            }
        }
        setRecoilIsLoadinBox(false);
    }, [data]);
    // 화사 추가
    function onClickCompanyInsert(e) {
        setSiteStates({
            siteType: "company",
            companyId: "",
            companyName: "",
        });
        setWorkMode("CREATE");
    }
    // 화사 선택
    function onClickCompanyView(e, company) {
        setSiteStates({
            siteType: "company",
            companyId: company.companyId,
            companyName: company.companyName,
        });
        setWorkMode("READ");
    }
    // 사업장 추가
    function onClickZoneInsert(e, company) {
        e.stopPropagation();
        setSiteStates({
            siteType: "zone",
            companyId: company.companyId,
            companyName: company.companyName,
        });
        setWorkMode("CREATE");
    }
    function ShearchGo(e) {
        setTreeSearchText(searchText);
    }
    function shearchDel(e) {
        setSearchText("");
        setTreeSearchText("");
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            ShearchGo(e);
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box treebar pushy-menutype type2" }, { children: [_jsxs("div", Object.assign({ className: "box__search type-line" }, { children: [_jsx("input", { type: "text", placeholder: "\uD68C\uC0AC\uB97C \uAC80\uC0C9\uD558\uC138\uC694", onKeyDown: (e) => searchEnter(e), value: searchText, onChange: (e) => setSearchText(e.target.value) }), searchText.length > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => shearchDel(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uAC80\uC0C9\uC5B4 \uC0AD\uC81C" })) }))), _jsx("button", Object.assign({ type: "button", className: "btn btn-search", onClick: (e) => ShearchGo(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("div", Object.assign({ className: "box__header" }, { children: _jsx("button", Object.assign({ type: "button", className: "add__item", onClick: (e) => onClickCompanyInsert(e) }, { children: _jsx("span", { children: "\uD68C\uC0AC \uCD94\uAC00" }) })) })), _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: companyList.length > 0 ? (companyList.map((company, idx) => (_jsxs("li", Object.assign({ className: company.companyId === siteStates.companyId ? "active" : "", onClick: (e) => onClickCompanyView(e, company) }, { children: [_jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: company.companyName }) })) }), _jsx("ul", Object.assign({ className: "lnb-depth2" }, { children: _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: `add__item ${siteStates.siteType === "ZONE" && workMode === "CREATE" ? "active" : ""}`, onClick: (e) => onClickZoneInsert(e, company) }, { children: _jsx("span", { children: "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00" }) })) }) }))] }), `comp_${idx.toString()}`)))) : (_jsx("li", { children: _jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: "\uD68C\uC0AC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." }) })) }) })) })) }))] })) }));
}
export default SiteTree;
